module.exports = __webpack_public_path__ + "img/votes_icon.df7c78c2.png";